/**
 * @generated SignedSource<<6710a374def3f7e9f84083d03e33d76a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountScreenQuery$variables = Record<PropertyKey, never>;
export type AccountScreenQuery$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"AccountView_user">;
  } | null | undefined;
};
export type AccountScreenQuery = {
  response: AccountScreenQuery$data;
  variables: AccountScreenQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountView_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailMarketingEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isEmailNotificationsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPushNotificationsEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5cd270816096ff52937114a7921e614b",
    "id": null,
    "metadata": {},
    "name": "AccountScreenQuery",
    "operationKind": "query",
    "text": "query AccountScreenQuery {\n  currentUser {\n    ...AccountView_user\n    id\n  }\n}\n\nfragment AccountView_user on User {\n  isEmailMarketingEnabled\n  isEmailNotificationsEnabled\n  isMetricSystem\n  isPushNotificationsEnabled\n  ...useSetUserEmailMarketingEnabledMutation_user\n  ...useSetUserEmailNotificationsEnabledMutation_user\n  ...useSetUserIsMetricSystemMutation_user\n}\n\nfragment useSetUserEmailMarketingEnabledMutation_user on User {\n  rowId\n}\n\nfragment useSetUserEmailNotificationsEnabledMutation_user on User {\n  rowId\n}\n\nfragment useSetUserIsMetricSystemMutation_user on User {\n  rowId\n}\n"
  }
};

(node as any).hash = "658289c24b41e8dfd275e71c3b0cb2ef";

export default node;
